export const rtlDictionary = {
	'ar-sa': true,
	'he-il': true
};
